<template> </template>
<script>
export default {
  name: "nitrozen-snackbar",
  props: {},
  data() {
    return {};
  },
  computed: {}
};
</script>

<style lang="less">
@import "./less/snackbar.less";
</style>
